import http from '@/axios'

class allServices {
 
  resetPassword (data) {
    return http.post('/ClientUser/reset_password', data)
  }
  forgotPassword (data) {
    return http.post('/auth/ClientUser/forget_password', data)
  }
  login (data) {
    return http.post('/auth/ClientUser/login', data)
  }
  logout () {
    return http.get('/ClientUser/logout')
  }
  fetch_accessible_module_list () {
    console.log('Initiating fetch accessible module list API')
    return http.get('/ClientUser/fetch_custom_module')
  }
}

export default new allServices()